import {useRouteError} from 'react-router-dom'
import {Button, ButtonType} from '@UI/components/controls/Button/Button.tsx'
import {PageNotFound} from '@UI/illustrationsSvg/PageNotFound.tsx'
import {SomeError} from '@UI/illustrationsSvg/SomeError.tsx'
import {
    Title_20_Coral_Strong_emphasis_20
} from '@UI/typography/generated/typography.tsx'
import {Stack} from '../../CommonComponents/Stack/Stack.tsx'
import {Gt} from '../../i18n/Gt.tsx'
import {Home} from "@UI/components/icons/Home.tsx";
import {Refresh} from "@UI/components/icons/Refresh.tsx";
import {Colors} from "@UI/theme/generated/Colors.ts";

import styles from "./errorLayer.module.less"

export const ErrorPage = ({header = true}: { header?: boolean }) => {
    const error = useRouteError()
    if (error)
        return (
            <Stack direction={"column"} grow justifyContent={"center"} alignItems={"center"} gap={32} className={styles.baseErrorPopup}>
                <SomeError/>
                <Title_20_Coral_Strong_emphasis_20>
                    <Gt>Something went wrong</Gt>
                </Title_20_Coral_Strong_emphasis_20>
                <Stack gap={8}>
                    <Button type={ButtonType.third} icon={<Refresh color={Colors.Coral_moss_700}/>}
                            onClick={() => window.location.reload()}>
                        <Gt>Reload</Gt>
                    </Button>
                    <Button href={'/'} type={ButtonType.primary} icon={<Home/>}>
                        <Gt>Back to home</Gt>
                    </Button>
                </Stack>
            </Stack>
        )
}

export const NotFountPage = () => (
    <Stack direction={"column"} grow justifyContent={"center"} alignItems={"center"} gap={32} className={styles.baseErrorPopup}>
        <PageNotFound/>
        <Title_20_Coral_Strong_emphasis_20>
            <Gt>404 Page Not Found</Gt>
        </Title_20_Coral_Strong_emphasis_20>
        <Button href={'/'} type={ButtonType.primary} icon={<Home/>}>
            <Gt>Back to home</Gt>
        </Button>
    </Stack>
)

